<template>
    <span
        class="status"
        :class="status.class"
        v-tooltip="{
            side: 'top',
            content: true,
            customClass: 'bg-dark text-white',
            content: showTooltip ? status.tooltip : ''
        }"
    >
        <span>{{ status.label }}</span>
        <a-icon
            style="margin-right: -6px;"
            v-if="status.icon || showIcon"
            :icon="status.icon || 'Info'"
        />
    </span>
</template>

<script>
export default {
    props: {
        state: {
            type: String,
            required: true
        },
        showTooltip: {
            type: Boolean,
            default: true
        },
        tooltip: {
            type: String,
            required: false
        },
        showIcon: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        status() {
            switch (this.state) {
            case 'accepted':
                return {
                    class: 'is-success',
                    label: 'Aktywna'
                }
            case 'available':
                return {
                    class: 'is-pending',
                    label: 'Dostępna'
                }
            case 'interrupted':
                return {
                    class: 'is-canceled',
                    label: 'Przerwana',
                    icon: 'Info',
                    tooltip:
                            'Promocja przerwana. Ponowna aktywacja promocji będzie możliwa jutro'
                }
            case 'deleted':
                return {
                    class: 'is-canceled',
                    label: 'Anulowana'
                }
            case 'incompatible':
                return {
                    class: 'is-incompatible',
                    label: 'Niekompatybilna',
                    icon: 'Info',
                    tooltip: this.$brand.promotions.incompatibleTooltipText
                }
            case 'conflict':
                return {
                    class: 'is-error',
                    label: 'Konflikt',
                    icon: 'Info',
                    tooltip:
                            'Co najmniej jeden EAN w obecnie aktywowanej promocji, występuje już w innej, aktywnej promocji w tym sklepie. Kliknij w pole konflikt, aby przejść do oferty powodującej konflikt. Przerwij trwającą promocję jeśli chcesz aktywować nową promocję na ten sam EAN.'
                }
            case 'cancelled_by_company':
                return {
                    class: 'is-error',
                    label: 'Odrzucona'
                }
            case 'cancelled':
                return {
                    class: 'is-error',
                    label: 'Odrzucona'
                }
            case 'archived':
                return {
                    class: 'is-canceled',
                    label: 'Zarchiwizowana'
                }
            case 'pending_accept':
                return {
                    class: 'is-warning',
                    label: 'W trakcie aktywowania'
                }
            case 'pending_interrupt':
                return {
                    class: 'is-warning',
                    label: 'W trakcie anulowania'
                }
            case 'problem':
                return {
                    class: 'is-warning',
                    label: 'W trakcie anulowania'
                }
            case 'invalid_company_merchant_status':
                return {
                    class: 'is-warning',
                    label: 'Nieaktywna usługa'
                }
            case 'suspended':
                return {
                    class: 'is-incompatible',
                    label: 'Zamknięcie sklepu',
                    icon: 'Info',
                    tooltip:
                            'Nie możesz aktywować promocji, ponieważ zaczyna się ona po zakończeniu współpracy ze wskazanym sklepem.'
                }
            case 'subscription_suspended':
                return {
                    class: 'is-warning',
                    label: 'Zawieszona'
                }
            case 'locked_at':
                return {
                    class: 'is-warning',
                    label: 'Zablokowana',
                    icon: this.tooltip ? 'Info' : null,
                    tooltip: this.tooltip
                }
            default: {
                return {
                    class: 'is-error',
                    label: 'Brak statusu'
                }
            }
            }
        }
    }
}
</script>
